import { homepageBreadcrumbs, PageContextProvider } from './index'

const page: PageContextProvider = (context) => {
  return {
    name: 'community',
    url: '/community',
    breadcrumbs: [
      homepageBreadcrumbs(context.modules),
      {
        phrase: ['Forum', 'nav.title.community.overview'],
        url: './'
      }
    ]
  }
}

export default page
